<template>
  <footer class="footer">
    <div class="layout-center-wrap footer__inner">
      <div class="footer__logo">
        <img src="@/assets/img/logo_wide.png" alt="" class="light-only" />
        <img src="@/assets/img/logo_wide_white.png" alt="" class="dark-only" />
      </div>
      <ul class="footer__info__list">
        <li class="footer__info">
          <p class="footer__info__tit">나주 본원</p>
          (58324) 전라남도 나주시 진흥길 9 한국인터넷진흥원
        </li>
        <li class="footer__info">
          <p class="footer__info__tit">서울 청사</p>
          (05717) 서울시 송파구 중대로 135 (가락동) IT벤처타워
        </li>
        <li class="footer__info">
          <p class="footer__info__tit">대표번호  </p>
          1433-25(수신자 요금 부담)
        </li>
        <li class="footer__info">
          <p class="footer__info__tit">해킹ㆍ스팸개인정보침해 신고</p>
          118
        </li>
      </ul>
      <div class="footer__link-copy-wrap">
        <div class="footer__link__wrap">
          <router-link to="/footer/privacyPolicy" class="footer__link"
            >개인정보 처리방침</router-link
          >
          <router-link to="/footer/rss" class="footer__link">RSS</router-link>
          <router-link to="/about/guide" class="footer__link"
            >사이트 이용안내</router-link
          >
          <router-link to="/overview/faq" class="footer__link"
            >자주묻는 질문</router-link
          >
          <router-link
            to="/member/remove"
            class="footer__link"
            v-if="route.path === '/member/myPage'"
            >회원 탈퇴</router-link
          >
        </div>
        <p class="footer__copy">Copyright(C) 2026 KISA. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { useRoute } from "vue-router";

export default {
  setup() {
    const route = useRoute();

    // html에서 사용될 데이터 정의
    return { route };
  },
};
</script>

<style>
</style>